module.exports = __webpack_public_path__ + "static/updates-bcdd28b4fef26dd7f783a8a7fff6c931.mp4";